import styled from "styled-components/macro";
import { useFields } from "../../hooks/use-fields";
import Keyword from "./Keyword";
import Button from "../Button";
import { Plus } from "../Icons";
import { OnChange } from "../../hooks/use-optional-state";
import { EditableCampaignKeyword } from ".";

type Props = {
  value: EditableCampaignKeyword[];
  onChange: OnChange<EditableCampaignKeyword[]>;
};

function Keywords({ value, onChange }: Props) {
  const { field, value: keywords } = useFields({ value, onChange });

  const addNew = () => {
    onChange((keywords) => [
      ...keywords,
      {
        keyword: "",
      },
    ]);
  };

  const remove = (index: number) => () => {
    onChange((keywords: EditableCampaignKeyword[]) =>
      keywords.map((item, i) =>
        i !== index ? item : { ...item, _destroy: true }
      )
    );
  };

  return (
    <>
      {keywords.map((keyword, index) =>
        keyword._destroy ? null : (
          <Keyword key={index} {...field(index)} onRemove={remove(index)} />
        )
      )}
      <KeywordAddBoxContent>
        <div>
          <KeywordAddButton onClick={addNew} variant="link">
            <Plus /> <span>Add Keyword</span>
          </KeywordAddButton>
        </div>
      </KeywordAddBoxContent>
    </>
  );
}

const KeywordAddBoxContent = styled.div`
  margin: 10px 0;
`;

const KeywordAddButton = styled(Button)`
  padding-left: 0px;
`;

export default Keywords;
